<template>
    <div class="border-settings mt-20">
        <!-- border-radius -->
        <div class="border-settings__row">
            <span>{{ t("common.border_radius") }}:</span>
            <div>
                <div class="border-settings__controllers" v-if="!customMode.border_radius">
                    <BuilderCoordsInputPart
                        :borderRadiusIndicator="true"
                        indicatorDir="top"
                        :min="0"
                        width="30px"
                        emitType="default"
                        :value="customStyles.border_radius.top"
                        @update="e => updateVal(e, 'border_radius', 'top')"
                    />
                    <BuilderCoordsInputPart
                        :borderRadiusIndicator="true"
                        indicatorDir="right"
                        :min="0"
                        width="30px"
                        emitType="default"
                        :value="customStyles.border_radius.right"
                        @update="e => updateVal(e, 'border_radius', 'right')"
                    />
                    <BuilderCoordsInputPart
                        :borderRadiusIndicator="true"
                        indicatorDir="bottom"
                        width="30px"
                        :min="0"
                        emitType="default"
                        :value="customStyles.border_radius.bottom"
                        @update="e => updateVal(e, 'border_radius', 'bottom')"
                    />
                    <BuilderCoordsInputPart
                        :borderRadiusIndicator="true"
                        indicatorDir="left"
                        width="30px"
                        :min="0"
                        emitType="default"
                        :value="customStyles.border_radius.left"
                        @update="e => updateVal(e, 'border_radius', 'left')"
                    />
                </div>
                <div class="border-settings__controllers" v-else>
                    <BuilderCoordsInputPart
                        width="30px"
                        :min="0"
                        emitType="default"
                        :value="customStyles.border_radius.top"
                        @update="e => updateVal(e, 'border_radius', 'all')"
                    />
                </div>
            </div>
            <svg
                class="border-settings__icon-target"
                :class="{ active: !customMode.border_radius }"
                @click="toggleCustomMode('border_radius')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 3V21M3 12L21 12M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
                    stroke="#323030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <!-- /border-radius -->

        <!-- border-->
        <div class="border-settings__row">
            <span>{{ t("common.border_thickness") }}:</span>
            <ColorInput
                @update="e => updateVal(e, 'border', 'color')"
                v-model="customStyles.border.color"
                :absolute="false"
                :marginBottom="0"
                :diameter="20"
                usedColorsMode
                softPalette
            />

            <div>
                <div class="border-settings__controllers" v-if="customMode.border">
                    <BuilderCoordsInputPart
                        :borderIndicator="true"
                        indicatorDir="top"
                        width="30px"
                        :min="0"
                        emitType="default"
                        :value="customStyles.border.top"
                        @update="e => updateVal(e, 'border', 'top')"
                    />
                    <BuilderCoordsInputPart
                        :borderIndicator="true"
                        :min="0"
                        indicatorDir="right"
                        width="30px"
                        emitType="default"
                        :value="customStyles.border.right"
                        @update="e => updateVal(e, 'border', 'right')"
                    />
                    <BuilderCoordsInputPart
                        :borderIndicator="true"
                        :min="0"
                        indicatorDir="bottom"
                        width="30px"
                        emitType="default"
                        :value="customStyles.border.bottom"
                        @update="e => updateVal(e, 'border', 'bottom')"
                    />
                    <BuilderCoordsInputPart
                        :borderIndicator="true"
                        :min="0"
                        indicatorDir="left"
                        width="30px"
                        emitType="default"
                        :value="customStyles.border.left"
                        @update="e => updateVal(e, 'border', 'left')"
                    />
                </div>
                <div class="border-settings__controllers" v-else>
                    <BuilderCoordsInputPart
                        width="30px"
                        :min="0"
                        emitType="default"
                        :value="customStyles.border.top"
                        @update="e => updateVal(e, 'border', 'all')"
                    />
                </div>
            </div>
            <svg
                class="border-settings__icon-target"
                :class="{ active: customMode.border }"
                @click="toggleCustomMode('border')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 3V21M3 12L21 12M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
                    stroke="#323030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <!-- /border-->

        <!-- shadow -->
        <div class="border-settings__row">
            <span>{{ t("common.shadow") }}:</span>
            <ColorInput
                v-model="customStyles.shadow.color"
                @update="e => updateVal(e, 'shadow', 'color')"
                :absolute="false"
                :marginBottom="0"
                :diameter="20"
                usedColorsMode
                softPalette
            />

            <div class="border-settings__controllers" v-if="customMode.shadow">
                <BuilderCoordsInputPart
                    width="30px"
                    :value="customStyles.shadow.x"
                    label="X"
                    labelSide="left"
                    emitType="default"
                    @update="e => updateVal(e, 'shadow', 'x')"
                />
                <BuilderCoordsInputPart
                    width="30px"
                    :value="customStyles.shadow.y"
                    label="Y"
                    labelSide="left"
                    emitType="default"
                    @update="e => updateVal(e, 'shadow', 'y')"
                />
                <BuilderCoordsInputPart
                    width="30px"
                    :value="customStyles.shadow.blur"
                    label="Blur"
                    labelSide="left"
                    emitType="default"
                    @update="e => updateVal(e, 'shadow', 'blur')"
                />
                <BuilderCoordsInputPart
                    width="30px"
                    :value="customStyles.shadow.spread"
                    emitType="default"
                    label="Spread"
                    labelSide="left"
                    @update="e => updateVal(e, 'shadow', 'spread')"
                />
                <div class="border-settings__switcher-wrapper">
                    <span class="border-settings__controllers-label">Outline</span>
                    <FormSwitcher
                        :smallSize="true"
                        v-model="customStyles.shadow.inset"
                        :val="customStyles.shadow.inset"
                        @input="e => updateVal(e, 'shadow', 'inset')"
                    />
                    <span class="border-settings__controllers-label">Inset</span>
                </div>
            </div>

            <svg
                class="border-settings__icon-target"
                :class="{ active: customMode.shadow }"
                @click="toggleCustomMode('shadow')"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 3V21M3 12L21 12M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z"
                    stroke="#323030"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <!-- /shadow -->
    </div>
</template>

<script>
import BuilderCoordsInputPart from "@components/Builder/components/BuilderCoordsInputPart.vue"
import ColorInput from "@components/Builder/components/ColorInput/ColorInput.vue"
import FormSwitcher from "@components/Forms/FormSwitcher.vue"
import { t } from "@helpers"

export default {
    name: "BuilderBorderSettings",
    components: {
        BuilderCoordsInputPart,
        FormSwitcher,
        ColorInput
    },
    props: {
        customStyles: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            customMode: {
                border_radius: false,
                border: false,
                shadow: false
            }
        }
    },
    methods: {
        toggleCustomMode(type) {
            if (!this.customMode[type]) {
                this.$emit("update", { chapter: type, val: this.customStyles[type].top, prop: "all" })
            }
            this.customMode[type] = !this.customMode[type]
        },
        updateVal(val, chapter, prop) {
            this.$emit("update", { chapter, val, prop })
            if (prop === "all") {
                this.customStyles[chapter].top = val
                this.customStyles[chapter].right = val
                this.customStyles[chapter].bottom = val
                this.customStyles[chapter].left = val
            } else this.customStyles[chapter][prop] = val
        }
    }
}
</script>

<style lang="scss" scoped>
.border-settings {
    font-family: Inter, sans-serif;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    &__row {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    &__icon-target {
        cursor: pointer;
        &:hover > path {
            stroke: #3965ff;
        }
    }
    &__icon-target.active {
        > path {
            stroke: #3965ff;
        }
    }
    &__controllers {
        display: flex;
    }
    &__switcher-wrapper {
        display: flex;
        gap: 3px;
        align-items: center;
    }
    &__controllers-label {
        font-family: Inter, sans-serif;
        font-size: 10px;
        font-weight: 400;
        line-height: 12px;
        color: #b5c1d2;
    }
}

//icons
.border-settings__icon-target {
    cursor: pointer;
    > path {
        stroke: #323030;
    }
    &:hover > path {
        stroke: #3965ff;
    }
}
.border-settings__icon-target.active {
    > path {
        stroke: #3965ff;
    }
}
</style>
